module.exports = __webpack_public_path__ + "static/img/rank_118.da31621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_118.png
// module id = pAF0
// module chunks = 0